import axios from "axios"
import TokenService from "./TokenService"
import VueJwtDecode from "vue-jwt-decode"
import router from "../router/index";

const Repository = {
  init(baseURL) {
    axios.defaults.baseURL = baseURL
  },

  setHeaders() {
    axios.defaults.headers.common["authorization"] =
      "Bearer " + TokenService.getToken()
    axios.defaults.headers.common["userId"] = VueJwtDecode.decode(
      TokenService.getToken()
    ).userId
    //axios.defaults.headers.common['userId'] = 3;
    axios.defaults.headers.common["companyId"] = VueJwtDecode.decode(
      TokenService.getToken()
    ).companyId
  },

  removeHeader() {
    axios.defaults.headers.common = {}
  },

  get(resource) {
    return axios.get(resource)
  },

  post(resource, data) {
    const headers = {
      Authorization:
        localStorage.getItem("userToken") ,
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    };
    return axios.post(resource, data, { headers })
  },

  postFile(resource, file) {
    const formData = new FormData()
    const headers = { "Content-Type": "multipart/form-data" }
    formData.append("attachment", file)
    return axios.post(resource, formData, { headers })
  },

  put(resource, data) {
    return axios.put(resource, data)
  },

  delete(resource) {
    return axios.delete(resource)
  },

  patch(resource, data) {
    return axios.patch(resource, data)
  },

  /**
   * Perform a custom Axios request.
   *
   * data is an object containing the following properties:
   *  - method
   *  - url
   *  - data ... request payload
   *  - auth (optional)
   *    - username
   *    - password
   **/
  customRequest(data) {
    return axios(data)
  },
}

axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    let response = error.response;
    if (response) {
      //console.log("response error:", response.data && response.data.access);
      if (response.status === 401) {
        router.push('/error401');
      } else if (response.status === 500) {
        router.push('/error500');
      }else if (response.status === 403) {
        router.push('/error403');
      }else if (response.status === 404) {
        router.push('/error404');
      }
    }else {
      // Manejo de errores sin respuesta (por ejemplo, problemas de red)
      console.error('Error de red o del servidor:', error.message);
    } 
  }
);

export default Repository
